import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  Renderer2,
  ViewChild
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

const NCHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NCheckboxComponent),
  multi: true
};

@Component({
  selector: "n-checkbox",
  styleUrls: [
    "./n-checkbox.css"
  ],
  templateUrl: "./n-checkbox.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    NCHECKBOX_VALUE_ACCESSOR
  ]
})
export class NCheckboxComponent implements ControlValueAccessor {

  @Input() description: string;
  @Input() name: string;
  @Input() text: string;

  checked: boolean;

  @ViewChild("input", {read: ElementRef, static: true})
  input: ElementRef;

  private propagateChange: (_) => void;
  private propagateTouch: () => void;
  _disabled: boolean;

  constructor(private renderer: Renderer2, private cd: ChangeDetectorRef) {

  }

  @Input()
  set disabled(val: boolean) { // deprecated
    this.setDisabledState(val);
  }

  @Input()
  set isDisabled(val: boolean) {
    this.setDisabledState(val);
  }

  get disabled(): boolean {
    return this._disabled;
  }

  onChange(event) {
    if (this.propagateChange) {
      this.propagateChange(event.target.checked);
    }
  }

  onTouched() {
    if (this.propagateTouch) {
      this.propagateTouch();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  writeValue(obj: boolean): void {
    this.renderer.setProperty(this.input.nativeElement, "checked", obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
    this.renderer.setProperty(this.input.nativeElement, "disabled", isDisabled);
    this.cd.markForCheck();
  }

}

